import { createFileRoute, Navigate } from '@tanstack/react-router';

/**
 * Impersonation handoff consumer. The session is seeded BEFORE the router mounts
 * by impersonation-bootstrap (imported first in main.tsx), which also strips the
 * URL back to `/`. This route is the fallback for the rare case the URL is still
 * `/login/impersonate` when the router evaluates: it just redirects to the lobby.
 *
 * Placed OUTSIDE the `_auth` pathless layout so `requireGuest` never redirects it.
 */
export const Route = createFileRoute('/login/impersonate')({
  component: ImpersonateConsumer,
});

function ImpersonateConsumer() {
  return <Navigate to="/" />;
}
